import PropTypes from 'prop-types'
import React, { Component } from 'react'
import DropZone from 'react-dropzone'
import { connect } from 'react-redux'

import {
  buyHelper,
  phaseChange,
  reroute,
  storeDumpItForce,
  toggleHelpDocumenti,
} from '../../../actions/Buy'
import {
  nltFileUploadDropped,
  nltFileUploadRemoved,
  postDocumentiUploadV1,
} from '../../../actions/noleggia/Documenti'
import {
  getNltDocumentiV1,
  postNltThankYouV1,
} from '../../../actions/noleggia/Nlt'
import fbPixel, { FB_EVENTS } from '../../../utils/fbpixel'
import { getFromFee } from '../../../utils/nltUtils'
import { filesBaseUrl } from '../../buy/utils'
import triggerDataLayerEvent, {
  CRITEO_EVENTS,
  EVENT_TYPES,
  GA_EVENTS,
  triggerClickStreamEvent,
} from '../../triggerDataLayerEvent'
import DocumentiHelper from '../dumb/DocumentiHelper'

const GREY800 = '#212121'

class DocumentiNlt extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.uploadInProgress = false
    this.state.toTop = false
    this.state.upload_btn_disabled = true
    this.buildListaDocumentiSelezionatiPerUpload =
      this.buildListaDocumentiSelezionatiPerUpload.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.onOpenClick = this.onOpenClick.bind(this)
    this.removeFile = this.removeFile.bind(this)
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 40, last: 30 })
    this.props.getNltDocumentiV1().then(() => {
      this.props.storeDumpItForce()
    })

    // BRUM-6741 si mostra subito l'help di come far le foto ai documenti
    setTimeout(() => this.props.toggleHelpDocumenti(true), 3000)
  }

  onDrop(acceptedFiles) {
    if (this.state.upload_btn_disabled) {
      this.setState({ upload_btn_disabled: acceptedFiles.length <= 0 })
    }
    this.props.nltFileUploadDropped({ dropzone: acceptedFiles })
  }

  onOpenClick(event) {
    event.stopPropagation()
    event.preventDefault()
    this.dropzone.open()
  }

  buildListaDocumentiNecessari() {
    const t = this
    const docSorted = t.props.nlt.documenti_necessari.sort((a, b) => {
      // porta il codice fiscale in testa
      if (a.nome.indexOf('Codice Fiscale') !== -1) {
        return -1
      }

      if (b.nome.indexOf('Codice Fiscale') !== -1) {
        return 1
      }

      return 0
    })

    return docSorted.map((documento, i) => (
      <li key={i}>
        <span className={`document_name red-before`}>
          <label className="r-checkbox" style={{ color: GREY800 }}>
            <input type="checkbox" />
            {documento.nome}
            <a className="upload-mobile">
              <i className="icon-arrow_double_right"></i>
            </a>
          </label>
        </span>
      </li>
    ))
  }

  buildListaDocumentiSelezionatiPerUpload() {
    const t = this
    return t.props.nlt.dropzone.map((documento, i) => (
      <li key={i}>
        <div className={'file_preview'}>
          {documento.type.indexOf('image') !== -1 && (
            <img src={documento.preview} />
          )}
          {documento.type === 'application/pdf' && (
            <img src={`${filesBaseUrl}/asset_sito/icona-documento.png`} />
          )}
        </div>
        <div className={'file_link'}>
          <a
            className={'file_link--label'}
            href={documento.preview}
            rel="noreferrer"
            target="_blank"
          >
            {documento.name}
          </a>
        </div>
        <span className={'file_remove'}>
          <a className="file_remove--link" onClick={this.removeFile()}>
            <i className="icon-close file_remove--icon" id={`remove-${i}`}></i>
          </a>
        </span>
      </li>
    ))
  }

  handleSubmit() {
    const t = this
    if (!this.props.fetching) {
      if (!this.state.upload_btn_disabled) {
        t.props.reroute().then(() => {
          t.setState({ uploadInProgress: true })
          this.props.postDocumentiUploadV1().then(() => {
            triggerDataLayerEvent(GA_EVENTS.Purchase_noleggio)
            fbPixel(FB_EVENTS.Purchase, this.props.product)
            t.props.postNltThankYouV1().then(() => {
              triggerClickStreamEvent(
                CRITEO_EVENTS.GROSS_ORDER_NLT,
                EVENT_TYPES.CRITEO,
                {
                  email: this.props.customer.email,
                  transactionId: this.props.ordine.id_ordine,
                  idAuto: this.props.product.id_auto,
                  price: getFromFee(
                    'canone_mensile',
                    this.props.nlt.selectedCanone
                  ),
                }
              )

              t.props.reroute('/thank-you')
            })
          })
        })
      }
    }
  }

  removeFile() {
    const that = this
    return e => {
      e.preventDefault()
      e.stopPropagation()
      that.props.nltFileUploadRemoved(e.target.id.replace('remove-', ''))
      if (that.props.nlt.dropzone.length === 0) {
        that.setState({ upload_btn_disabled: true })
      }
    }
  }

  render() {
    const submitDisabled = this.props.fetching || this.state.upload_btn_disabled
    const dropZoneHasDocs = this.props.nlt.dropzone.length > 0

    return (
      <div>
        <div className="process__header hide-print">
          <h1 className="process__title hide-print">Carica i tuoi documenti</h1>
          <p className="process__intro hide-print">
            Aiutaci a raccogliere i documenti che servono a completare la tua
            richiesta di noleggio.
          </p>
        </div>
        <div className={'messages warning'}>
          <div className={'container'}>
            <p>
              Vuoi proseguire in un secondo momento? &nbsp;Controlla la casella
              di posta e assicurati di aver confermato il tuo indirizzo.
              &nbsp;Riceverai un’email di <em>Recupero ordine</em>
              &nbsp;che ti consentirà di concludere il processo entro 14 giorni.
            </p>
          </div>
        </div>
        <div className="user-informations">
          <div className="container--small">
            <div className="documents__upload">
              <div className="documents__upload__left">
                <div className="documents_list">
                  <ul>
                    <li className="title">
                      <span className={'only-desktop'}>
                        Ciao &nbsp;
                        <span className={'user_name'} data-hj-suppress>
                          {this.props.customer.nome}
                        </span>
                        , &nbsp;carica i seguenti documenti:
                      </span>
                      <span className={'only-mobile'}>
                        Ciao &nbsp;
                        <span className={'user_name'} data-hj-suppress>
                          {this.props.customer.nome}
                        </span>
                        , &nbsp;ci servono questi documenti:
                      </span>
                    </li>

                    {this.props.nlt.documenti_necessari.length > 0 &&
                      this.buildListaDocumentiNecessari()}

                    <li>
                      <span>
                        <label
                          style={{ paddingTop: '10px', fontStyle: 'italic' }}
                        >
                          brumbrum S.p.A si riserva il diritto di richiedere
                          documentazione aggiuntiva ove necessario.
                        </label>
                      </span>
                    </li>

                    {dropZoneHasDocs && (
                      <li className={'files__list hidden-md'}>
                        <ul>
                          <li className={'title small'}>Documenti caricati:</li>
                          {this.buildListaDocumentiSelezionatiPerUpload()}
                        </ul>
                      </li>
                    )}

                    {dropZoneHasDocs ? (
                      <li className="last">
                        <a
                          className={
                            submitDisabled
                              ? 'btn btn-primary btn-disabled'
                              : 'btn btn-primary'
                          }
                          onClick={this.handleSubmit}
                        >
                          <span>Avvia richiesta noleggio</span>
                        </a>
                      </li>
                    ) : null}
                  </ul>
                </div>
              </div>
              <div className="documents__upload__right">
                <DocumentiHelper
                  flowType={'rent'}
                  onClick={() => this.props.toggleHelpDocumenti(true)}
                />
                <DropZone
                  accept="application/pdf,image/jpg,image/jpeg,image/png"
                  activeClassName="drag_accept"
                  className="drag_drop"
                  onDrop={this.onDrop}
                  ref={node => {
                    this.dropzone = node
                  }}
                  rejectClassName="drag_reject"
                >
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} className="drag_drop__content">
                      <input {...getInputProps()} />
                      <i className="icon-upload"></i>
                      <h2>Trascina qui i tuoi documenti</h2>
                      <span style={{ fontSize: '12px' }}>
                        (formati consentiti .jpg, .jpeg, .png, .pdf - max 50MB)
                      </span>
                    </div>
                  )}
                </DropZone>
                <div className="documents__upload__other">
                  <span className="documents__upload__other__or only-desktop">
                    <span>Oppure</span>
                  </span>
                  <div className="file-upload-box">
                    <div
                      className="fileUpload btn btn-secondary"
                      onClick={this.onOpenClick}
                    >
                      <span className={'only-desktop'}>Scegli un file</span>
                      <span className={'only-mobile'}>
                        Carica/Scatta una foto
                      </span>
                      <input className="upload" id="uploadBtn" type="file" />
                    </div>

                    {dropZoneHasDocs && (
                      <li
                        className={'files__list hidden-lg'}
                        style={{ listStyle: 'none' }}
                      >
                        <ul>
                          <li className={'title small'}>Documenti caricati:</li>
                          {this.buildListaDocumentiSelezionatiPerUpload()}
                        </ul>
                      </li>
                    )}

                    {dropZoneHasDocs ? (
                      <div className="only-mobile">
                        <a
                          className={
                            submitDisabled
                              ? 'btn btn-primary btn-disabled'
                              : 'btn btn-primary'
                          }
                          onClick={this.handleSubmit}
                        >
                          <span>Avvia richiesta noleggio</span>
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="contacts_list">
              <ul>
                <li className="title">
                  <span>
                    Problemi con l'upload?
                    <br />
                    Chiama il Servizio Clienti allo <b>02.800.29</b>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

DocumentiNlt.propTypes = {
  customer: PropTypes.object,
  fetching: PropTypes.bool,
  nlt: PropTypes.object,
  getNltDocumentiV1: PropTypes.func,
  nltFileUploadDropped: PropTypes.func,
  nltFileUploadRemoved: PropTypes.func,
  postDocumentiUploadV1: PropTypes.func,
  ordine: PropTypes.object,
  phaseChange: PropTypes.func,
  product: PropTypes.object,
  reroute: PropTypes.func,
  storeDumpItForce: PropTypes.func,
  ui: PropTypes.object,
  buyHelper: PropTypes.func,
  toggleHelpDocumenti: PropTypes.func,
}

const mapStateToProps = state => ({
  customer: state.customer,
  fetching: state.ui.fetching,
  nlt: state.nlt,
  ordine: state.ordine,
  product: state.product,
  ui: state.ui,
})

const mapDispatchToProps = dispatch => ({
  getNltDocumentiV1: () => dispatch(getNltDocumentiV1),
  postNltThankYouV1: () => dispatch(postNltThankYouV1),
  nltFileUploadDropped: payload => dispatch(nltFileUploadDropped(payload)),
  nltFileUploadRemoved: payload => dispatch(nltFileUploadRemoved(payload)),
  phaseChange: phase => dispatch(phaseChange(phase)),
  postDocumentiUploadV1: () => dispatch(postDocumentiUploadV1),
  reroute: payload => dispatch(reroute(payload)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  buyHelper: () => dispatch(buyHelper()),
  toggleHelpDocumenti: newState => dispatch(toggleHelpDocumenti(newState)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DocumentiNlt)
